module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-12.5922493e.JPG";